module.exports = __webpack_public_path__ + "static/logo-europos-komisija-35016c8ac8e700ade4d65d45934eb934.svg";